import styled, { css } from "styled-components";
import { bold as boldStyles, fonts } from ".";

const Link = styled.a`
    text-decoration: underline;
`;

const BaseText = styled.p`
    font-size: 0.875rem;
    ${props => props.bold && boldStyles};
`;

const HeaderSmall = styled.h3`
    font-size: 1rem;
    ${boldStyles};
`;

const textStyles = css`
    ${({ size }) =>
        size === "inherit" ? "font-size: inherit" : fonts.typeScale[size]};
    ${({ bold }) => (bold ? boldStyles : null)};
    color: ${({ color }) => (color ? color : "inherit")};
`;

const A = styled.a`
    ${textStyles};
    text-decoration: underline;
`;

/* use for text that looks like a link,
but doesn't actually take the user to a new page */
const ButtonLink = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    ${textStyles};
    text-decoration: underline;
`;

const P = styled.p`
    ${textStyles};
`;

// use headings.js instead of these headings - we will deprecate these:
const H1 = styled.h1`
    ${textStyles};
`;

const H2 = styled.h2`
    ${textStyles};
`;

const H3 = styled.h3`
    ${textStyles};
`;

export {
    Link,
    BaseText,
    HeaderSmall,
    textStyles,
    A,
    P,
    H1,
    H2,
    H3,
    ButtonLink
};
